import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { type IApplicationContext } from '@/microfrontends/filters/shared/types/applicationContext';

import { REDUCERS_MAP } from '../../internal/reduxReducer';
import { type TReduxPreloadedState } from '../../types';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createReduxStore(
  context: IApplicationContext,
  preloadedState: TReduxPreloadedState | undefined,
  debugEnabled: boolean,
) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    preloadedState,
    reducer: combineReducers(REDUCERS_MAP),
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      });
    },
    devTools: debugEnabled ? { name: projectName } : false,
  });
}
